import React from 'react';
import ComingSoon from './components/ComingSoon';
import './App.css';

function App() {
  return (
    <div className="App">
      <ComingSoon />
    </div>
  );
}

export default App;
